import React, { useState } from "react";
import Swal from "sweetalert2";
import * as yup from "yup";
import AppForm from "../../../../partials/content/Forms/AppForm";
import { DateTime } from "luxon";
import {
  FormArraySelectField,
  FormArrayTextField2,
  FormDateField,
  FormTextField,
} from "../../../../partials/content/Forms/FormField";
import { useFormikContext } from "formik";
import ContentLayout from "../../../../partials/content/ContentLayout";
import { Tab, Tabs } from "react-bootstrap";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchPlant from "../plant/SearchPlant";
import { DialogActions } from "@material-ui/core";
import SearchItem from "../../inventory/items/searchItem";
import SearchItemUom from "../../inventory/items/searchItemUom";
import {
  getProductionDetail,
  saveProductionOrder,
} from "../../../../services/production/productionService";
import SearchPlantWarehouse from "../plant/SearchPlantWarehouse";
const productionOrderFormSchema = () => {
  return yup.object().shape({
    plantName: yup.string().required("Plant is required"),
    itemName: yup.string().required("Production Item is required"),
    prodQty: yup.number().min(1, "Production qty cannot be zero"),
    uomName: yup.string().required("Unit is required"),
    boms: yup.array().of(
      yup.object().shape({
        bomStockPlan: yup.array().of(
          yup.object().shape({
            warehouseName: yup.string("Warehouse is required"),
            qty: yup.number().min(1, "Qty is required"),
          })
        ),
      })
    ),
  });
};
function ProductionOrderForm({ history }) {
  const [productionOrder, setProductionOrder] = useState({
    ID: 0,
    plantID: 0,
    plantName: "",
    statusID: 1,
    itemID: 0,
    varCode: "",
    itemName: "",
    prodQty: 0,
    uomID: 0,
    uomName: "",
    planStartDate: DateTime.now().startOf("day"),
    planEndDate: DateTime.now().startOf("day"),
    confirmStartDate: DateTime.now().startOf("day"),
    confirmEndDate: DateTime.now().startOf("day"),
    boms: [],
    routings: [],
  });

  return (
    <ContentLayout>
      <AppForm
        initialValues={productionOrder}
        validationSchema={productionOrderFormSchema}
        headSubmitButton
        onSubmit={(values, { resetForm, setStatus, setSubmitting }) => {
          const productionOrder = { ...values };
          for (const bom of productionOrder.boms) {
            bom.qty = parseFloat(bom.qty);
            for (const plan of bom.bomStockPlan) {
              plan.qty = parseFloat(plan.qty);
            }
          }
          productionOrder.prodQty = parseFloat(productionOrder.prodQty);
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title: "Are you sure want to save this Production Order ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                saveProductionOrder(productionOrder).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Saved",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        }}
      >
        <PageSubHeader
          title="Production Order Form"
          breadcrumbs={[
            { page: "/menu", title: "Menu", active: false },
            {
              page: "/production/production-order",
              title: "Production Order List",
              active: false,
            },
            {
              page: "/production/production-order-form",
              title: "Production Order Form",
              active: true,
            },
          ]}
          actionButtons={[
            {
              title: "",
              color: "label-brand",
              icon: "fas fa-backward",
              onClick: () => {
                history.push("/production/production-order");
              },
            },
          ]}
        />
        <ProductionOrderFormContent />
      </AppForm>
    </ContentLayout>
  );
}

function ProductionOrderFormContent() {
  const [tab, setTab] = useState({
    ID: 1,
    title: "Sellable Items",
    icon: "fas fa-boxes",
  });
  const { values, setFieldValue } = useFormikContext();
  const [openSearchPlant, setOpenSearchPlant] = useState(false);
  const [openSearchItem, setOpenSearchItem] = useState(false);
  const [openSearchUom, setOpenSearchUom] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedIndex2, setSelectedInde2] = useState(0);
  const [openSearchWarehouse, setOpenSearchWarehouse] = useState(false);
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6">
          <FormTextField
            label="Plant"
            name="plantName"
            searchButton
            clearButton
            readonly
            onSearchClick={() => {
              setOpenSearchPlant(true);
            }}
            onClearFields={() => {
              setFieldValue("plantID", 0);
              setFieldValue("plantName", "");
              setOpenSearchPlant(false);
            }}
          />
          <FormTextField
            label="Production Item"
            name="itemName"
            searchButton
            clearButton
            readonly
            onSearchClick={() => {
              setOpenSearchItem(true);
            }}
            onClearFields={() => {
              setFieldValue("itemID", 0);
              setFieldValue("varCode", "");
              setFieldValue("itemName", "");
              setOpenSearchItem(false);
            }}
          />
          <FormTextField
            label="Production Qty"
            name="prodQty"
            quantityField
            onBlur={(value) => {
              const boms = [...values.boms];
              const prodQty = parseFloat(value);
              for (const bom of boms) {
                //bom.bomStockPlan = [];
                for (const stockPlan of bom.bomStockPlan) {
                  stockPlan.qty = 0;
                }
                bom.qty = bom.qtyOri * prodQty;
              }
              setFieldValue("boms", boms);
            }}
          />
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6">
          <FormDateField name="planStartDate" label="Plan Start Date" />
          <FormDateField name="planEndDate" label="Plan End Date" />
          <FormTextField
            label="Uom"
            name="uomName"
            searchButton
            clearButton
            readonly
            onSearchClick={() => {
              setOpenSearchUom(true);
            }}
            onClearFields={() => {
              setFieldValue("uomID", 0);
              setFieldValue("uomName", "");
            }}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <Tabs defaultActiveKey="bom" className="mb-3">
            <Tab eventKey="bom" title="Bill of Material">
              <table className="table">
                <thead>
                  <tr>
                    <th>Item ID</th>
                    <th>Item Name</th>
                    <th>Qty</th>
                    <th>Unit</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {values.boms.map((bom, index) => {
                    const planOptions = [
                      {
                        value: 1,
                        label: "Item Reservation",
                      },
                    ];
                    if (bom.itemType === 4) {
                      planOptions.push({
                        value: 2,
                        label: "Create Production Order",
                      });
                    }

                    return (
                      <React.Fragment>
                        <tr key={index}>
                          <td>{bom.reqItemID}</td>
                          <td>{bom.reqItemName}</td>
                          <td>{bom.qty}</td>
                          <td>{bom.uomName}</td>
                          <td>
                            {!bom.deleteInd ? (
                              <button
                                type="button"
                                className="btn btn-sm btn-primary float-right"
                                onClick={() => {
                                  const bomStockPlan = [...bom.bomStockPlan];
                                  bomStockPlan.push({
                                    planType: 1,
                                    warehouseID: 0,
                                    warehouseName: "",
                                    qty: 0,
                                  });
                                  setFieldValue(
                                    `boms[${index}].bomStockPlan`,
                                    bomStockPlan
                                  );
                                }}
                              >
                                Add Plan
                              </button>
                            ) : null}
                          </td>
                          <td>
                            <button
                              type="button"
                              className={`btn btn-sm btn-${
                                bom.deleteInd ? "warning" : "danger"
                              } float-right`}
                              onClick={() => {
                                const boms = [...values.boms];
                                boms[index].deleteInd = !bom.deleteInd;
                                boms[index].bomStockPlan = [];
                                setFieldValue(`boms`, boms);
                              }}
                            >
                              {bom.deleteInd ? "Undo Delete" : "Delete"}
                            </button>
                          </td>
                        </tr>
                        {bom.bomStockPlan &&
                          bom.bomStockPlan.map((plan, index2) => (
                            <tr key={index2}>
                              <td>
                                <FormArraySelectField
                                  label="Plan Type"
                                  arrayPropName="boms"
                                  arrayPropName2="bomStockPlan"
                                  propName="planType"
                                  index={index}
                                  index2={index2}
                                  options={planOptions}
                                  onSelectChange={() => {}}
                                />
                              </td>
                              <td>
                                <FormArrayTextField2
                                  label="Warehouse"
                                  arrayPropName="boms"
                                  arrayPropName2="bomStockPlan"
                                  propName="warehouseName"
                                  index={index}
                                  index2={index2}
                                  searchButton
                                  clearButton
                                  readonly
                                  onSearchClick={() => {
                                    setSelectedIndex(index);
                                    setSelectedInde2(index2);
                                    setOpenSearchWarehouse(true);
                                  }}
                                  onClearFields={() => {
                                    setFieldValue(
                                      `boms[${selectedIndex}].bomStockPlan[${selectedIndex2}].warehouseID`,
                                      0
                                    );
                                    setFieldValue(
                                      `boms[${selectedIndex}].bomStockPlan[${selectedIndex2}].warehouseName`,
                                      ""
                                    );
                                  }}
                                />
                              </td>
                              <td>
                                <FormArrayTextField2
                                  label="Qty"
                                  arrayPropName="boms"
                                  arrayPropName2="bomStockPlan"
                                  propName="qty"
                                  index={index}
                                  index2={index2}
                                />
                              </td>
                              <td></td>
                              <td></td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger float-right"
                                  onClick={() => {
                                    const bomStockPlan = [...bom.bomStockPlan];
                                    bomStockPlan.splice(index2, 1);
                                    setFieldValue(
                                      `boms[${index}].bomStockPlan`,
                                      bomStockPlan
                                    );
                                  }}
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </Tab>
            <Tab eventKey="routing" title="Routing">
              <table className="table">
                <thead>
                  <tr>
                    <th>Step</th>
                    <th>Operation</th>
                  </tr>
                </thead>
                <tbody>
                  {values.routings.map((routing, index) => (
                    <tr key={index}>
                      <td>{routing.step}</td>
                      <td>{routing.operationName}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Tab>
          </Tabs>
        </div>
      </div>
      <DialogLayout
        open={openSearchPlant}
        title="Search Plant"
        onCloseDialog={() => {
          setOpenSearchPlant(false);
        }}
        maxWIdth="md"
      >
        <SearchPlant
          onSelectPlant={(plant) => {
            setFieldValue("plantID", plant.ID);
            setFieldValue("plantName", plant.plantName);
            setOpenSearchPlant(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchPlant(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchItem}
        title="Search Item"
        onCloseDialog={() => {
          setOpenSearchItem(false);
        }}
        maxWIdth="md"
      >
        <SearchItem
          tab={tab}
          selectProductionItems={true}
          selectSellableItems={false}
          selectServiceItems={false}
          selectItemPackages={false}
          selectAssetItems={false}
          selectVariant={true}
          onSelectItem={(item, itemPackage, varCode, valueName) => {
            setFieldValue("itemID", item.ID);
            setFieldValue("varCode", varCode);
            setFieldValue("itemName", item.itemName + " " + valueName);
            getProductionDetail(item.ID, varCode).then((response) => {
              const { data } = response.data;
              setFieldValue("boms", data.boms);
              setFieldValue("routings", data.routings);
              setOpenSearchItem(false);
            });
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchItem(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchUom}
        title="Search Uom"
        onCloseDialog={() => {
          setOpenSearchUom(false);
        }}
        maxWIdth="md"
      >
        <SearchItemUom
          itemID={values.itemID}
          onSelectUom={(uom) => {
            setFieldValue("uomID", uom.ID);
            setFieldValue("uomName", uom.uom);
            setOpenSearchUom(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchUom(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchWarehouse}
        title="Search Warehouse"
        onCloseDialog={() => {
          setOpenSearchWarehouse(false);
        }}
        maxWIdth="md"
      >
        <SearchPlantWarehouse
          plantID={values.plantID}
          onSelectWarehouse={(warehouse) => {
            setFieldValue(
              `boms[${selectedIndex}].bomStockPlan[${selectedIndex2}].warehouseID`,
              warehouse.ID
            );
            setFieldValue(
              `boms[${selectedIndex}].bomStockPlan[${selectedIndex2}].warehouseName`,
              warehouse.warehouseName
            );
            setOpenSearchWarehouse(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchWarehouse(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}
export default ProductionOrderForm;
